/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    young<yangyang@frippler.com>
  | @Title:     账户管理-收货地址 API 接口
  | @Version:   2018-12-25  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function getAddressListApi(query) {
  return request({
    url: '?c=fam&a=address&do=list',
    method: 'get',
    params: query
  })
}

export function postAddressApi(formData) {
  return request({
    url: '?c=fam&a=address&do=post',
    method: 'post',
    data: formData
  })
}

export function setDefaultAddressApi(formData) {
  return request({
    url: '?c=fam&a=address&do=default',
    method: 'post',
    data: formData
  })
}

export function deleteAddressApi(formData) {
  return request({
    url: '?c=fam&a=address&do=delete',
    method: 'post',
    data: formData
  })
}

export function getAddressApi(addressid) {
  return request({
    url: '?c=fam&a=address&do=get',
    method: 'get',
    params: { addressid }
  })
}
